import {ScheduledReportFileType, ScheduledReportRecurrence, StandardDateRange} from "@/lib/queries/reports";

export const ScheduledReportRecurrenceLabel: Record<ScheduledReportRecurrence, string> = {
  [ScheduledReportRecurrence.DAILY]: "Daily",
  [ScheduledReportRecurrence.WEEKLY]: "Weekly",
  [ScheduledReportRecurrence.MONTHLY]: "Monthly",
  [ScheduledReportRecurrence.QUARTERLY]: "Quarterly",
  [ScheduledReportRecurrence.YEARLY]: "Yearly",
};

export const ScheduledReportFileTypeLabel: Record<ScheduledReportFileType, string> = {
  [ScheduledReportFileType.PDF]: "PDF",
  [ScheduledReportFileType.XLS]: "XLS",
};

export const ScheduledReportRangeOverrideOptions = [
  StandardDateRange.TODAY,
  StandardDateRange.YESTERDAY,
  StandardDateRange.LAST_7D,
  StandardDateRange.LAST_30D,
  StandardDateRange.THIS_WEEK,
  StandardDateRange.LAST_WEEK,
  StandardDateRange.THIS_MONTH,
  StandardDateRange.LAST_MONTH,
  StandardDateRange.THIS_QUARTER,
  StandardDateRange.LAST_QUARTER,
  StandardDateRange.THIS_YEAR,
  StandardDateRange.LAST_YEAR,
];
